import moment from 'moment';
import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* therapistAssignmentUndo(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.undoTherapistAssignment,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: TherapistAction.THERAPIST_TASK_ASSIGN_UNDO_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
        payload: {
          data: {
            providerId: action.payload.providerId,
            localDate: action.payload?.currentDate,
            type: action.payload.type,
            active: true,
            discipline: action.payload.discipline,
            skill: action.payload.skill,
            isV2: action.payload?.isV2,
          },
          pageNo: action.payload.meta.taskPage,
          pageSize: 20,
        },
      });
      yield put({
        type: TherapistAction.DISABLE_AUTO_MATCH_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          discipline: action.payload.discipline,
          currentDate: action.payload?.currentDate,
        },
      });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          localDate: action.payload?.currentDate,
          data: { isV2: action.payload?.isV2 },
        },
      });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
        payload: {
          pageSize: 20,
          pageNo: action.payload.meta.therapistPage,
          data: {
            providerId: action.payload.providerId,
            localDate: action.payload?.currentDate,
            discipline: action.payload.discipline,
            sortBy: action.payload.sortBy,
            searchData: action.payload?.searchData,
            filterByUuid: action.payload?.filterByUuid,
          },
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: TherapistAction.THERAPIST_TASK_ASSIGN_UNDO_FAILURE, payload: error });
  }
}

function* therapistAssignmentUndoSaga() {
  yield takeEvery(TherapistAction.THERAPIST_TASK_ASSIGN_UNDO_REQUEST, therapistAssignmentUndo);
}

export default therapistAssignmentUndoSaga;
